// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"2924a4fa","824":"9055dbae"}[chunkId] + ".chunk.css";
};